module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "مارتن_بالاس-الطابق_السابع-أمبرا-جريجيا"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("#مارتن_بالاس #الطَّابق_السَّابع #أمبرا جريجيا")])]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "width": "2.78125in",
      "height": "0.33647in"
    },
    attrs: {
      "alt": " ",
      "src": "media/file1.png"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لوي فانديزا ذو الثمانية والعشرين ربيعًا، المدير التَّنفيذي والمؤسِّس لشركة أمبرا جريجيا للخدمات الفندقيَّة الخاصَّة باستيراد أفخم أنواعِ النَّبيذِ الصَّرف وأعتقها في القارَّة الأستراليَّة، والذي يبدو منغمسًا بكومة الأوراق والملفَّات التي تأخذُ الحيِّز الأكبر مِن طاولة مكتبه الزجاجيَّة الضخمة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("النَّافذة الزجاجيَّة التي تحتلُّ جدارًا كاملًا خلفه سمحَت لأشعة الشمس المتمرِّدة بمداعبة بشرته البيضاء المائلة إلى الشحوب، لَم يبدُ أنَّ الأمر قد أزعجه البتَّة، مسد شعرَه الدَّاكن الحريريّ إلى الخلفِ، وعادَ ليُمسكَ بالقلم مرَّة أخرى ليواصلَ عملَه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اقتحمَت دقَّاتٌ منتظمة هدوءَ المكتبِ، تجاهلَها، دقَّات أخرى بوتيرة أسرع، تجاهلَها مرَّة أخرى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دلفَ ذلك الأسمر الطويل ذو الملامح الحادَّة إلى المكتب، وهو يُلقي نظرةً خاطفةً على المكان ببطءٍ؛ عدا السَّجاد الفارسيّ المزخرف، الأثاث، الجدران، المدفأة، وحتَّى الأرضيَّة الرُّخاميّة اللَّامعة، كلُّها أخذَت اللَّونين الرَّماديَّ والأسوَد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تركَّزَت نظراتُه على صديقه الذي لَم يعِر أيّ اهتمامٍ لدخوله المكتب، واستمرَّ في قراءة الورق الذي بين يديه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline !important"
    }
  }, [_vm._v("كالمعتاد، ترفعُ أكمام قميصك الأسوَد إلى المنتصف متباهيًا بعضلات عضدكَ المشدودة، تُلقي بربطة عنقكَ على الأرض في إهمال، تبدو كمتشرّدٍ وسيمٍ ذي نفوذ فانديزا.")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- التزم الصمتَ كيفين!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ضربَ كيفين راحةَ يده على جبينه في دراميّة مجيبًا:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- آه! مجدَّدًا، نسِيتُ أنَّك تملكُ القدرة على قراءةِ ما يجولُ في نفس المرء! أخبرني، هل أنت بشريٌّ مثلنا حتَّى؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لوي في برودٍ:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سنوات طويلة هي عمرُ الصَّداقة التي تجمعُنا، وأنتَ إلى يومنا هذا لَم تعتَد على ما أنا عليه! بحقِّك كيفين، بيرون يتعاملُ مع الأمر بسهولةٍ، وأنتَ ما زلتَ مكشوفًا كالكتابِ المفتوح كلَّما التقَينا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مطَّ كاي شفتيه بغير اكتراثٍ وهو يأخذُ مقعدًا أمام لوي واضعًا قدمًا فوق الأخرى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أزاح بعضَ الأوراق التي كانت أمامه، لكن أحدَها أثار اهتمامه، فقال وهو يلقي نظرة:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- مدرسة الفان الخاصَّة، يبدو أنَّ أمبر تبلي جيِّدًا في هذه المدرسة، تكملُ عامها الثَّاني مِن غير أيّ مشكلات مِن الدَّرجة الأولى، والتي توجبُ نقلها إلى مدرسة أخرى، لِنرَ! بالنِّسبة إلى فتاةٍ انتقلَت إلى ستِّ مدارسَ خلال عامين ونصف في السَّابق، فهذا شيءٌ عظيم!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رفعَ لوي رأسَه ليواجه صديقه بابتسامة هادئة، إلَّا إنَّ عدستَي عينَي كاي اتَّسَعَت فجأةً ليلوحَ بالورقة التي بين يديه صائحًا:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- اللَّعنة! أتعلمُ ما الرُّسوم الفصليَّة التي تدفعُها لهذه المدرسة؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حافظَ لوي على ابتسامته، وأجاب بنفس الهدوء:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- مائة وأربعة عشرَ ألفًا وثلاثمائة دولارٍ أمريكي.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ضربَ كاي براحتيه على الطَّاولة في انفعال:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- والجحيم يا رجل! أنت تعلم أنَّه يمكنك شراءُ منزل في حيٍّ جميل بمبلغ قسطٍ واحدٍ!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("استقامَ لوي مجيبًا:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ولكنِّنا لا نسكنُ في منازل تقع في أحياء جميلة فحسب، تعلَمُ جيِّدًا أنّني وأنتَ نختار أرقاها وأجملها.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ثمَّ تقدّم نحو المقعد المقابل لكاي مردفًا:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هي في السنةِ الأخيرة دراسيًّا، وكونها سعيدة، وتتصرَّفُ جيّدًا يجعلني أشعر بالرَّاحة.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أومأ كاي موافِقًا:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- "), _c('strong', [_vm._v("صحيح! كونك لستَ مجبرًا على تأجيل اجتماعاتِك المهمَّة، أو مقاطعتها لزيارة المدرسة، وتوقيع تعهُّدات غير مجدِية النفع، أمرٌ يثيرُ الشعور بالرَّاحة فعلًا!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اتَّسَعَت ابتسامة لوي مربتًا على كتف صديقه:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أظنُّكَ عدتَ مِن النَّادي الرِّياضي للتوِّ، كيف تجري الأمور هناك؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("برقَت عينا كاي في حماسٍ:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- "), _c('strong', [_vm._v("كلُّ شيءٍ تحت السيطرة أيُّها الرئيس، ألا يبدو هذا واضحًا مِن بنية جسدي الرياضيَّة؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قالها وهو يربت على صدره في غرور مصطنَع.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("طرقٌ منتظم جعل الصديقان يلتفتان إلى الباب في وقت واحد.")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- تفضَّل أيُّها العم جيراد.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فتح الباب ليكشف عن وجه الطارق، رجل في نهاية العقد الخامس مِن العمر، شعر فضيّ لامع، تبدو عليه سماتُ الوقار والطيبة.")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سيِّدي.. لقد وصل ابني بيرون، وهو ينتظركم في الخارج.")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- شكرًا لك أيُّها العم، ماذا عن مستندات تجديدِ العقود الخاصة بالمورِّدين الأوروبيِّين؟")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- قسم الشؤون القانونيَّة يعمل عليها منذُ الصباح، كما أنَّنا أبلغنا المورِّد الرئيس بتأجيل اجتماع توقيع العقد كما أمرتَ سابقًا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("التقط لوي معطفه وهو يشير لكاي بالنهوض، فنظر إليه العم جيراد في هدوء قائلًا:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- إذا تمَّ تأجيل موعد الاجتماع الرئيس فهذا يعني...")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اقتربت خطوات لوي نحو سكرتيره الخاصّ أكثر لينحني نحو أذنه في هدوء يحمل مِن السخرية الكثير:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يعني أنَّه لَم يعُد المورِّد الرئيسي بعد الآن.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("همسَ بكلماته ليخرج خلف كاي تاركًا العجوز يتساءل عن مدى غرابة شخصيَّة سيِّده الصغير، هو طيِّبٌ كالملاك، عميقٌ كالظلام، ومخيف كأعماق الجحيم!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a10bb7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch008.vue
// module id = 87
// module chunks = 0